import React from 'react';
import { ComposableDevicesStoreInfoResponse } from '../../../../../service/store/hooks/useDevicesWithComposableDevice';
import { ComposableDevicesManagerStoreInfoResponse } from '../../../../../service/device/hooks/useDevicesManager';
import { Box, CircularProgress } from '@mui/material';
import { IconButton } from '../../../../../theme/ui/Atoms/Button/Button.stories';
import { EditIcon, TrashIcon } from '../../../../../assets';
import Button from '../../../../../theme/ui/Atoms/Button';
import { useTranslation } from 'react-i18next';
import { RemoveDeviceModal } from './RemoveDeviceModal';
import CloseIcon from '@mui/icons-material/Close';
interface DeviceActionsProps {
  device:
    | ComposableDevicesStoreInfoResponse
    | ComposableDevicesManagerStoreInfoResponse;
  isEditing: boolean;
  editingDeviceId?: string | null;
  isSaving?: boolean;
  setIsEditing: (device: string | null) => void;
  onSave: () => void;
  displayRemoveDeviceModal: boolean;
  setDisplayRemoveDeviceModal: (display: boolean) => void;
  canRemoveNode?: boolean;
  isOneCommanderOneComposableDevice?: boolean;
}
export const DeviceActions = (props: DeviceActionsProps) => {
  const {
    device,
    editingDeviceId,
    setIsEditing,
    onSave,
    isSaving,
    displayRemoveDeviceModal,
    setDisplayRemoveDeviceModal,
    canRemoveNode,
  } = props;
  const isDeviceSelected = editingDeviceId === device.uuid;

  const { t } = useTranslation();

  return (
    <>
      <Box
        display={'flex'}
        gap={2}
        padding={'1rem'}
        justifyContent="center"
        width={'12rem'}
      >
        {isDeviceSelected ? (
          <>
            <Button
              variant="contained"
              rounded
              fullWidth
              style={{ height: '2.5rem' }}
              onClick={(ev) => {
                ev.stopPropagation();
                onSave();
              }}
              disabled={isSaving}
            >
              {isSaving ? (
                <CircularProgress size={'1.5rem'} sx={{ color: 'white' }} />
              ) : (
                t('button.save')
              )}
            </Button>
            <IconButton
              variant="text"
              size="small"
              disabled={isSaving}
              sx={{
                minWidth: 'auto',
                padding: '0.5rem',
                borderRadius: '0.5rem',
                backgroundColor: 'transparent',
              }}
              onClick={(ev) => {
                ev.stopPropagation();
                setIsEditing(null);
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        ) : (
          <>
            <IconButton
              variant="contained"
              size="small"
              disabled={editingDeviceId !== null || isSaving}
              sx={{
                minWidth: 'auto',
                padding: '0.5rem 1.5rem',
                borderRadius: '0.5rem',
              }}
              onClick={(ev) => {
                ev.stopPropagation();
                setIsEditing(device.uuid);
              }}
            >
              <EditIcon height={'1.5rem'} />
            </IconButton>
            <IconButton
              variant="contained"
              size="small"
              disabled={editingDeviceId !== null || isSaving}
              sx={{
                minWidth: 'auto',
                padding: '0.5rem 1.5rem',
                borderRadius: '0.5rem',
              }}
              onClick={(ev) => {
                ev.stopPropagation();
                setDisplayRemoveDeviceModal(true);
              }}
            >
              <TrashIcon height={'1.5rem'} />
            </IconButton>
          </>
        )}
      </Box>
      <RemoveDeviceModal
        device={device}
        displayConfirmModal={displayRemoveDeviceModal}
        setDisplayConfirmModal={setDisplayRemoveDeviceModal}
        canRemoveNode={canRemoveNode}
        isOneCommanderOneComposableDevice={
          props.isOneCommanderOneComposableDevice
        }
      />
    </>
  );
};
